import { render, staticRenderFns } from "./ProjectTabOffers.vue?vue&type=template&id=17021b8a&scoped=true"
import script from "./ProjectTabOffers.vue?vue&type=script&lang=ts"
export * from "./ProjectTabOffers.vue?vue&type=script&lang=ts"
import style0 from "./ProjectTabOffers.vue?vue&type=style&index=0&id=17021b8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17021b8a",
  null
  
)

export default component.exports